<template>
	<div class="publish">
		<div style="">
			<el-row>
				<el-col :span="24" >
					<div class="img">
						<img src="../../assets/img/icon_checking.png" alt="">
					</div>
					
				</el-col>
				<el-col :span="24" >
					<p>
						您的信息还在审核中，暂时无法共享库存 
					</p>
				</el-col>
			</el-row>
			
		</div>

	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			form:{
				name:'',
			}

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {

	}
}
</script>
<style lang="less" scoped>
</style>